import { useMutation, useQueries, useQuery, useQueryClient } from '@tanstack/react-query';
import { Drawer } from 'antd';
import { Ellipsis, FloatingPanel, Grid, Image, Mask, Modal, Toast } from 'antd-mobile';
import { GridItem } from 'antd-mobile/es/components/grid/grid';
import { GlobalLoadingContext, NavListContext, NavShowContext } from 'App';
import img from 'app/img';
import Carousel from 'components/frame/carousel';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn'; // load on demand
import { open } from 'fs';
import SearchArea from 'pages/webapp/search/search-area';
import { useContext, useEffect, useState } from 'react';
import {
  AiFillCaretRight,
  AiFillCloseCircle,
  AiFillCloud,
  AiFillFile,
  AiFillFilter,
  AiFillFire,
  AiFillFlag,
  AiFillFolder,
  AiFillGitlab,
  AiFillHeart,
  AiFillProduct,
  AiFillRightCircle,
  AiFillRightSquare,
  AiFillSetting,
  AiOutlineClose,
  AiOutlineDoubleRight,
  AiOutlineFire,
} from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import PostsApi, { PagePostDT } from 'services/apis/cnt2/post-api';
import { UserPolyInfoDT } from 'services/apis/sys/user-api';
import { postSourceTypeMap, postTypeMap } from 'services/gather_bo/_total';
import { useImmer } from 'use-immer';
import { useWindowSize } from 'usehooks-ts';
import { localDatetime2Date } from 'utils/dateUtil';
import { getItemWithExpiration } from 'utils/localStorageUtil';
import { scrollTop } from 'utils/screenUtil';
import QuoteApp from './dnd';

const Osusume = () => {
  const navigate = useNavigate();
  const navList = useContext(NavListContext).navList;
  const userPolyInfo = getItemWithExpiration('userPolyInfo') as UserPolyInfoDT;

  const showGlobalLoading = useContext(GlobalLoadingContext).showGlobalLoading;
  const globalLoading = useContext(GlobalLoadingContext).globalLoading;

  const [openFeedDrawer, setOpenFeedDrawer] = useState(false);

  type CateDT = {
    bgColor: string;
    allowVipList: string[];
    allowVipLevelList: number[];
    cateList: {
      termId: string;
      label: string;
      icon: any;
      open: boolean;
    }[];
  }[];

  const cateList: CateDT = [
    {
      bgColor: 'bg-slate-200',
      allowVipList: ['次元会员', '全站通'],
      allowVipLevelList: [11, 12, 13, 14, 41, 42, 43, 44],

      cateList: [
        {
          termId: 'CAT_1_1',
          label: '动漫里番',
          icon: <AiFillFire size={24} />,
          open: true,
        },
        {
          termId: 'CAT_1_2',
          label: '漫画本子',
          icon: <AiFillFire size={24} />,
          open: true,
        },
        {
          termId: 'CAT_1_3',
          label: '绅士游戏',
          icon: <AiFillFire size={24} />,
          open: true,
        },
        {
          termId: 'CAT_1_4',
          label: '日轻小说',
          icon: <AiFillFire size={24} />,
          open: true,
        },
        {
          termId: 'CAT_1_6',
          label: 'ASMR',
          icon: <AiFillFire size={24} />,
          open: true,
        },
        {
          termId: 'CAT_1_5',
          label: '萌妹COS',
          icon: <AiFillFire size={24} />,
          open: true,
        },
      ],
    },
    {
      bgColor: 'bg-violet-200',
      allowVipList: ['福利会员', '全站通'],
      allowVipLevelList: [21, 22, 23, 24, 41, 42, 43, 44],
      cateList: [
        {
          termId: '1',
          label: 'COSAV',
          icon: <AiFillFire size={24} />,
          open: false,
        },
        {
          termId: '1',
          label: '网曝门',
          icon: <AiFillFire size={24} />,
          open: false,
        },
        {
          termId: '1',
          label: '探花外围',
          icon: <AiFillFire size={24} />,
          open: false,
        },
        {
          termId: '1',
          label: '反差网红',
          icon: <AiFillFire size={24} />,
          open: false,
        },
        {
          termId: '1',
          label: '黄播传媒',
          icon: <AiFillFire size={24} />,
          open: false,
        },
        {
          termId: '1',
          label: '主播热舞',
          icon: <AiFillFire size={24} />,
          open: false,
        },
      ],
    },
    {
      bgColor: 'bg-orange-200',
      allowVipList: ['暗网会员', '全站通'],
      allowVipLevelList: [31, 32, 33, 34, 41, 42, 43, 44],
      cateList: [
        {
          termId: '1',
          label: '初中生',
          icon: <AiFillFire size={24} />,
          open: false,
        },
        {
          termId: '1',
          label: '萝莉岛',
          icon: <AiFillFire size={24} />,
          open: false,
        },
        {
          termId: '1',
          label: '凌辱调教',
          icon: <AiFillFire size={24} />,
          open: false,
        },
        {
          termId: '1',
          label: '同门乱伦',
          icon: <AiFillFire size={24} />,
          open: false,
        },
        {
          termId: '1',
          label: '强奸迷奸',
          icon: <AiFillFire size={24} />,
          open: false,
        },
        {
          termId: '1',
          label: '暗网重口',
          icon: <AiFillFire size={24} />,
          open: false,
        },
      ],
    },
  ];

  type OsusumeTermDT = {
    termId: string;
    termLabel: string;
    pageSize: number;
    column: number;
    osusumeLevel: number;
    osusumePostList?: PagePostDT[];
  };
  const osusumeTermList: OsusumeTermDT[] = [
    { termId: 'CAT_1_1', termLabel: '动画里番', osusumeLevel: 1, pageSize: 6, column: 2, osusumePostList: [] },
    { termId: 'CAT_1_2', termLabel: '漫画本子', osusumeLevel: 1, pageSize: 6, column: 3, osusumePostList: [] },
    { termId: 'CAT_1_3', termLabel: '绅士游戏', osusumeLevel: 1, pageSize: 6, column: 2, osusumePostList: [] },
    { termId: 'CAT_1_4', termLabel: '日轻小说', osusumeLevel: 1, pageSize: 6, column: 3, osusumePostList: [] },
    { termId: 'CAT_1_6', termLabel: 'ASMR', osusumeLevel: 1, pageSize: 6, column: 2, osusumePostList: [] },
    { termId: 'CAT_1_5', termLabel: '萌妹COS', osusumeLevel: 1, pageSize: 6, column: 3, osusumePostList: [] },
  ];
  // const [lastestPostList, setLastestPostList] = useState<PagePostDT[]>();
  // const [osusumePostList, updateOsusumePostList] = useImmer<OsusumeTermDT[]>(osusumeTermList);
  const fetchLastestPostList = async () => {
    // 最新帖子
    const resp = await PostsApi.page(
      { cantCache: true, termId: null, termTaxonomy: 'category', osusume: false },
      { pageParams: { current: 0, pageSize: 18 * 5 } }
    );
    if (resp.successful) {
      // setLastestPostList(resp.result.records);
      return resp.result.records;
    }
  };

  const fetchOsusumePostList = async (data: OsusumeTermDT) => {
    // 推荐帖子
    const resp = await PostsApi.polyOsusume(
      { termId: data.termId, osusumeLevel: data.osusumeLevel },
      { pageParams: { current: 0, pageSize: data.pageSize } }
    );
    if (resp.successful) {
      // 根据termId设置数据
      // updateOsusumePostList((draft) => {
      //   draft.find((d) => d.termId === data.termId).osusumePostList = resp.result.records;
      // });
      return resp.result.records;
    }
  };

  // const fetchOsusumePostListQuery = useQuery({
  //   queryKey: ['fetchOsusumePostList', term.termId, term.osusumeLevel],
  //   queryFn: () => {
  //     return fetchOsusumePostList(term);
  //   },
  // });

  // 获取当前时间到下一个中午12点的毫秒数
  const getNextNoon = () => {
    const now = new Date();
    const nextNoon = new Date();
    nextNoon.setHours(12, 0, 0, 0); // 设置到今天的12点

    if (now >= nextNoon) {
      // 如果当前时间已经过了今天的12点，设置为明天的12点
      nextNoon.setDate(now.getDate() + 1);
    }

    return nextNoon.getTime() - Date.now(); // 返回剩余毫秒数
  };

  const queryClient = useQueryClient();
  const fetchOsusumePostListQueries = useQueries({
    queries: osusumeTermList.map((term) => {
      return {
        queryKey: ['fetchOsusumePostList', term.termId, term.osusumeLevel],
        queryFn: () => {
          return fetchOsusumePostList(term);
        },
        // staleTime: getNextNoon(), // 设置为距离下一个12点的时间差
      };
    }),
  });

  const fetchLastestPostListQuery = useQuery({
    queryKey: ['fetchLastestPostList'],
    queryFn: () => {
      return fetchLastestPostList();
    },
    // staleTime: getNextNoon(), // 设置为距离下一个12点的时间差
  });

  useEffect(() => {
    // fetchLastestPostList();
    // osusumeTermList.forEach((term) => {
    //   fetchOsusumePostList(term);
    // });
  }, []);

  const updateNavShowState = useContext(NavShowContext).updateNavShowState;

  // 修改导航
  useEffect(() => {
    scrollTop();
    updateNavShowState((draft) => {
      draft.showBottomNav = true;
      draft.showTop1Nav = false;
      draft.showTop2Nav = false;
      draft.showTitleNav = true;
    });
  }, []);

  // 页面内容
  return (
    <div className="">
      {/* 轮播图 */}
      <div className=" p-0">
        <Carousel
          showBtn={false}
          height={window.outerWidth / 2.5}
        />
      </div>

      {/* 精选专辑 */}
      {true && (
        <div className=" overflow-hidden">
          {cateList.map((cateItem, cateIndex) => (
            <div
              key={cateIndex + cateItem.bgColor}
              className={[
                cateItem.bgColor,
                ' px-2 py-2 flex justify-between gap-1.5 items-center text-orange-500 flex-wrap',
              ].join(' ')}
            >
              {cateItem.cateList.map((item, index) => (
                <div
                  key={cateIndex + cateItem.bgColor + index}
                  className={[
                    ' grow',
                    ' flex flex-col flex-shrink-0 justify-center items-center gap-0.5 ',
                    ' w-14 h-14 bg-gradient-to-br from-white from-20% to-slate-200/50 shadow-xl rounded-xl p-2',
                  ].join(' ')}
                  onClick={() => {
                    // vip鉴权
                    if (cateItem.allowVipLevelList && cateItem.allowVipLevelList.length != 0) {
                      const vipLevelList = userPolyInfo.vipList
                        .filter((vip) => vip.usergroupActiveStatus == 1)
                        .map((vip) => vip.usergroupLevel);
                      let allow = false;
                      vipLevelList.forEach((vipLevel) => {
                        if (cateItem.allowVipLevelList.includes(vipLevel)) {
                          allow = true;
                        }
                      });
                      if (!allow) {
                        Modal.show({
                          closeOnAction: true,
                          closeOnMaskClick: true,
                          title: '暂无权限',
                          content: (
                            <div className=" text-pink-500/80 text-center font-bold">
                              {'请开通' + cateItem.allowVipList.map((item) => '【' + item + '】').join('或')}
                            </div>
                          ),
                          actions: [
                            {
                              key: 'levelup',
                              text: (
                                <div
                                  className=" bg-gradient-to-r from-violet-500 to-fuchsia-500 shadow-md rounded-md text-white p-2 mb-8 text-base"
                                  onClick={() => {
                                    navigate('/one/mine');
                                  }}
                                >
                                  限时开通
                                </div>
                              ),
                            },
                            {
                              key: 'img',
                              text: (
                                <>
                                  <div className=" pointer-events-none w-full z-0 absolute ring-0 -bottom-3 flex justify-end items-center">
                                    <img
                                      src={img.cute_cat}
                                      className=" w-20 h-16 object-cover object-top mr-4"
                                    />
                                  </div>
                                </>
                              ),
                            },
                          ],
                        });
                        return;
                      }
                    }

                    // 是否开放
                    if (item?.open) {
                      navigate('/term', {
                        state: {
                          term: { termUuid: item.termId, termName: item.label },
                          termTaxonomy: 'category',
                          staticPostList: null,
                        },
                      });
                    } else {
                      // TODO 禁止点击, 有数据后再开放
                      Toast.clear();
                      Toast.show('❤ 暂无权限 ❤');
                    }
                  }}
                >
                  <div>{item.icon}</div>
                  <div className=" text-nowrap text-orange-500 text-[11px]">{item.label}</div>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}

      {/* 搜索框 */}
      <div
        className=" py-1 bg-black bg-opacity-10"
        style={{ color: '#fff !important' }}
      >
        <SearchArea
          showSwitch={false}
          onHover={(onHover) => {}}
        />
      </div>

      {/* 修改订阅 */}
      <div className="  flex justify-center items-center">
        <div
          className=" relative bg-gradient-to-br from-purple-100 to-orange-200 p-2 m-2 shadow-md rounded-md flex justify-center items-center text-base text-purple-500/80 gap-2 mt-4 mb-0"
          onClick={() => {
            setOpenFeedDrawer(true);
          }}
        >
          <AiFillSetting size={20} />
          <div>我的订阅</div>
          <AiFillCloseCircle
            size={20}
            color="#ee6666"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              Modal.show({
                closeOnAction: true,
                closeOnMaskClick: true,
                showCloseButton: false,
                title: '提示',
                content: '可在【我的-应用设置】中再次开启',
                actions: [
                  {
                    key: 'action',
                    text: (
                      <div className=" flex justify-center items-center text-white text-sm gap-8">
                        <div className=" shadow-md rounded-md p-2 bg-pink-500/80">确定删除</div>
                        <div className=" shadow-md rounded-md p-2 bg-sky-500/80">我再想想</div>
                      </div>
                    ),
                  },
                ],
              });
            }}
          />
        </div>
      </div>

      {/* 订阅弹窗 */}
      <Drawer
        open={openFeedDrawer}
        placement={'left'}
        title={<div className=" -ml-4 w-full text-center text-base">修改订阅</div>}
        closeIcon={<div />}
        closable={true}
        maskClosable={true}
        destroyOnClose={true}
        onClose={() => {
          setOpenFeedDrawer(false);
        }}
        styles={{
          mask: { width: window.innerWidth },
          wrapper: { minWidth: 200, width: window.innerWidth * 0.75 },
          content: {},
          header: {},
          body: {},
          footer: {},
        }}
      >
        <QuoteApp
          onClose={() => {
            setOpenFeedDrawer(false);
          }}
        />
      </Drawer>

      {/* 最新上架 */}
      {true && (
        <div className=" m-2">
          {/* 标题 */}
          <div className=" mb-2 flex justify-between text-base bg-orange-0 text-slate-100 pt-2">
            <div className="flex justify-center items-center">
              <AiFillProduct
                size={22}
                className="mx-1 mb-1 text-orange-500"
              />
              <div className="text-slate-800 ">最新上架 (12:00每日更新)</div>
            </div>
            <div
              className={[
                'flex justify-center items-center bg-gradient-to-r from-slate-400 to-slate-500 shadow-md rounded-md pl-2 pr-1 py-1 text-sm',
              ].join(' ')}
              onClick={() => {
                navigate('/term', {
                  state: {
                    term: { termUuid: null, termName: '最新上架' },
                    termTaxonomy: 'static',
                    // staticPostList: lastestPostList,
                    staticPostList: fetchLastestPostListQuery?.data,
                  },
                });
              }}
            >
              <div className=" text-nowrap whitespace-nowrap">查看更多</div>
              <AiFillCaretRight
                size={20}
                className=" mb-0.5"
              />
            </div>
          </div>

          <div
            className={[
              ' min-h-40 flex flex-nowrap p-2 gap-2 rounded-md shadow-md bg-gradient-to-br from-sky-100 to-orange-200 w-full overflow-x-auto',
            ].join(' ')}
          >
            {fetchLastestPostListQuery?.data
              //@ts-ignore
              ?.slice(0, Math.min(10, fetchLastestPostListQuery?.data.length))
              ?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className=" flex-grow-0 relative shadow-md rounded-md"
                    onClick={() => {
                      navigate('/detail', {
                        state: { post: item, term: item.asTerms },
                      });
                    }}
                  >
                    <Image
                      key={index + ''}
                      fit="cover"
                      src={item.postCoverUrlList[0]}
                      width={window.outerWidth / 3.8}
                      height={window.outerWidth / 2.6}
                      className=" rounded-md shadow-md"
                      placeholder={
                        <img
                          src={img.loadingImg}
                          style={{
                            objectFit: 'cover',
                            width: window.outerWidth / 3.8,
                            height: window.outerWidth / 2.6,
                          }}
                        />
                      }
                      fallback={
                        <img
                          src={img.loadingImg}
                          style={{
                            objectFit: 'cover',
                            width: window.outerWidth / 3.8,
                            height: window.outerWidth / 2.6,
                          }}
                        />
                      }
                    />
                    <div
                      className=" rounded-bl-md rounded-br-md text-nowrap overflow-hidden text-xs absolute bottom-0 bg-gradient-to-r from-black/60 to to-black/30 text-white p-1"
                      style={{
                        width: window.outerWidth / 3.8,
                      }}
                    >
                      {item.postTitle}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      )}

      {/* 编辑推荐 */}
      <div>
        {/* 动画,漫画,游戏,轻小说,ASMR,COSPLAY */}
        {osusumeTermList?.map((osusumeTerm, osusumeTermIndex) => (
          <div
            key={osusumeTerm.termId}
            className=" min-h-96"
          >
            <div className=" mx-2 text-pink-500 text-center flex justify-between items-center">
              <div className=" w-12"></div>
              <div className=" text-pink-500 text-center flex justify-center items-center">
                {/* <AiFillHeart size={18} /> */}
                <div className=" m-2 text-base">{'推荐 ● ' + osusumeTerm.termLabel}</div>
                {/* <AiFillHeart size={18} /> */}
              </div>
              <div
                className=" w-12"
                onClick={() => {
                  navigate('/term', {
                    state: {
                      term: { termUuid: osusumeTerm.termId, termName: osusumeTerm.termLabel },
                      termTaxonomy: 'category',
                      staticPostList: null,
                    },
                  });
                }}
              >
                MORE+
              </div>
            </div>
            <Grid
              columns={osusumeTerm.column}
              gap={10}
              className=" min-h-96 mx-2 p-2 rounded-md shadow-md bg-gradient-to-br from-sky-100 to-orange-200"
            >
              {fetchOsusumePostListQueries[osusumeTermIndex]?.data?.map((item, postListIndex) => (
                <GridItem
                  key={postListIndex}
                  onClick={() => {
                    navigate('/detail', {
                      state: { post: item, term: item.asTerms },
                    });
                  }}
                >
                  <div className=" relative shadow-md rounded-md overflow-hidden">
                    <Image
                      height={window.outerWidth / (6 / osusumeTerm.column)}
                      key={osusumeTerm.termId + postListIndex}
                      fit="cover"
                      src={item.postCoverUrlList[0]}
                      lazy={true}
                      placeholder={
                        <img
                          src={img.loadingImg}
                          style={{
                            objectFit: 'cover',
                            width: '100%',
                            height: window.outerWidth / (6 / osusumeTerm.column),
                          }}
                        />
                      }
                      fallback={
                        <img
                          src={img.loadingImg}
                          style={{
                            objectFit: 'cover',
                            width: '100%',
                            height: window.outerWidth / (6 / osusumeTerm.column),
                          }}
                        />
                      }
                    />
                    <div className=" p-1.5 w-full rounded-bl-md rounded-br-md h-10 overflow-hidden text-xs absolute bottom-0 bg-gradient-to-r from-black/60 to bg-black/30 text-white">
                      {item.postTitle}
                    </div>
                    <div className=" absolute top-1 right-0 py-0.5 px-1 text-white bg-orange-500 bg-opacity-80 rounded-md shadow-md">
                      {postSourceTypeMap.get(item.postSourceType)}
                    </div>
                  </div>
                  <div className=" flex flex-wrap justify-between items-center text-sm my-1">
                    <div className=" flex justify-center items-center gap-0.5 text-nowrap">
                      <AiFillFire
                        color="red"
                        className=" opacity-50"
                      />
                      <div>{(item.asCoacts.coactHotIndex / 10000).toFixed(2) + ' w'}</div>
                    </div>
                    <div className=" flex justify-center items-center gap-0.5 text-nowrap">
                      <AiFillCloud
                        color="purple"
                        className=" opacity-50"
                      />
                      <div>
                        {Object.prototype.toString.call(item?.postUploadTime) === '[object String]'
                          ? dayjs(item?.postUploadTime).format('MM月DD日')
                          : dayjs(localDatetime2Date(item?.postUploadTime)).format('MM月DD日')}
                      </div>
                    </div>
                  </div>
                </GridItem>
              ))}
            </Grid>
            {/* 换一换*/}
            <center>
              <div
                onClick={() => {
                  if (globalLoading) {
                    return;
                  }
                  showGlobalLoading({ long: true });

                  queryClient.invalidateQueries({
                    queryKey: ['fetchOsusumePostList', osusumeTerm.termId, osusumeTerm.osusumeLevel],
                  });
                }}
                className=" p-2 m-4 w-24 border-2 border-slate-200 bg-pink-500 bg-opacity-50 text-base text-white rounded-md shadow-md text-center"
              >
                换一换
              </div>
            </center>
          </div>
        ))}
      </div>

      {/* <ImageList
        termName="资源总数"
        // termName={
        //   (navList.top2TermNow?.termName || navList.top1TermNow?.termName || navList.btmTermNow?.termName) +
        //   (!data.termName ? '' : ' : ' + data.termName) +
        //   ' (资源总数: ' +
        //   (fetchPostCountQuery.data || '加载中') +
        //   ')'
        // }
        termId={navList.top2TermNow?.termBgUrl || navList.top1TermNow?.termBgUrl || navList.btmTermNow?.termBgUrl}
        // postList={fetchPagePostQuery.data}
        postList={[]}
        showMore={true}
      /> */}
    </div>
  );
};

export default Osusume;
